import type { OneClickMvScene } from '@/app/types';
import { safeStorage } from './safe-storage';

const STORAGE_KEY = 'vidu-one-click-mv-task-scenes';
const MAX_STORED_TASKS = 100;

type StoredTaskScene = {
  scene: OneClickMvScene;
  savedAt: number;
};

type StoredTaskScenes = Record<string, StoredTaskScene>;

const isOneClickMvScene = (value: unknown): value is OneClickMvScene =>
  value === 'sing' || value === 'sing_act' || value === 'dance' || value === 'performance';

const readStoredTaskScenes = (): StoredTaskScenes => {
  const storedValue = safeStorage.getItem(STORAGE_KEY);
  if (!storedValue) return {};

  try {
    const parsed = JSON.parse(storedValue) as StoredTaskScenes;
    return Object.fromEntries(
      Object.entries(parsed).filter(([, item]) => isOneClickMvScene(item?.scene) && typeof item.savedAt === 'number'),
    );
  } catch {
    return {};
  }
};

export const saveOneClickMvTaskScene = (taskId: string, scene: OneClickMvScene) => {
  const storedScenes = readStoredTaskScenes();
  const nextEntries = Object.entries({
    ...storedScenes,
    [taskId]: { scene, savedAt: Date.now() },
  })
    .sort(([, a], [, b]) => b.savedAt - a.savedAt)
    .slice(0, MAX_STORED_TASKS);

  safeStorage.setItem(STORAGE_KEY, JSON.stringify(Object.fromEntries(nextEntries)));
};

export const getOneClickMvTaskScene = (taskId?: string): OneClickMvScene | undefined => {
  if (!taskId) return undefined;
  return readStoredTaskScenes()[taskId]?.scene;
};
